(() => {
  const sections = document.querySelectorAll('[data-fcw-section]');

  sections.forEach((section) => {
    const cards = section.querySelectorAll('[data-fcw-card]');
    if (!cards.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const delay = Number(entry.target.getAttribute('data-delay')) || 0;
          window.setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, delay);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -60px 0px'
      }
    );

    cards.forEach((card) => observer.observe(card));
  });
})();
